// ===========================LIVE URL==================
export const API_URL = 'https://api.algarxpress.com';
export const IMAGE_URL = 'https://algarxpress.s3.ap-south-1.amazonaws.com'
export const RETURN_URL_Wallet = 'https://algarxpress.com/allOrders'

// ===================demo==========================

// export const API_URL = 'http://localhost:8000'
// export const IMAGE_URL = 'https://algarxpress.s3.ap-south-1.amazonaws.com'
// export const RETURN_URL_Wallet = 'http://localhost:3000/allOrders'

